import React, { useEffect, useState } from "react";
import Button from "../../../../components/Button/Button";
import styles from "./kyc.module.scss";
import uploadAnimation from '../../../../assets/gif/uploadAnimation.gif';
import useMultipleFileUploadAws from "../../../../hooks/AWSFileUpload/useMultipleFileUploadAws";
import LinearProgressBar from "../../../../components/ProgressBar/LinearProgressBar";

function Selfie({ formData, setFormData, setActiveNav, handleInputChange }) {
    const [isUploading, setIsUploading] = useState(false); // Track upload status
    const [selectedImg, setSelectedImg] = useState("");
    const [uploadPreview, setUploadPreview] = useState(uploadAnimation);
    const {
        uploadErrors,
        uploadFileToS3,
        cancelUpload,
        mediaUrls,
        uploadProgresses,
        estimatedTimes,
    } = useMultipleFileUploadAws();

    const handleUpload = async () => {
        console.log('FormData: ', formData);
        if (formData.selfieImg) {
            setIsUploading(true); // Set uploading status to true
            await uploadFileToS3(formData.selfieImg);
            setIsUploading(false); // Reset uploading status
        }
    }

    useEffect(() => {
        if (mediaUrls && formData?.selfieImg?.name && mediaUrls[formData.selfieImg.name]) {
            setFormData((prevData) => ({
                ...prevData,
                selfieUrl: mediaUrls[formData.selfieImg.name],
            }));
            setUploadPreview(mediaUrls[formData.selfieImg.name]);
        }
    }, [mediaUrls, formData.selfieImg]);

    const handleFormSubmission = () => {
        if (formData.selfieImg && formData.selfieUrl) {
            console.log('Form Data :', formData);
            setActiveNav(4);
        } else {
            console.log('Incomplete Form Data :', formData);
            console.log('Please Fill all the details!');
        }
    }

    return (
        <form>
            <div className={styles.inputField}>
                <div className={styles.selfiePreviewContainer}>
                    <div className={styles.selfiePreview}>
                        {formData.selfieImg && <img src={URL.createObjectURL(formData.selfieImg)} alt="Selfie preview" />}
                    </div>
                    {formData.selfieImg && (
                        <LinearProgressBar progress={uploadProgresses[formData?.selfieImg?.name]} height="0.5rem" />
                    )}
                    <div className={styles.btnContainer}>
    <label htmlFor="selfie" className={styles.selfieBtn}>
        Take a Picture
    </label>
    {!isUploading && !mediaUrls[formData?.selfieImg?.name] && (
        <Button label={'Upload'} handleClick={handleUpload} />
    )}
</div>

                </div>
                <input
                    style={{ display: "none" }}
                    type="file"
                    id="selfie"
                    name="selfieImg"
                    accept="image/*"
                    capture="user"
                    onChange={handleInputChange}
                />
            </div>
            <div className={styles.btnContainer}>
                <Button label={"Back"} handleClick={() => setActiveNav(2)} disabled={isUploading} />
                <Button
                    label={isUploading ? "File being uploaded..." : "Next"}
                    handleClick={handleFormSubmission}
                    disabled={isUploading}
                />
            </div>
        </form>
    );
}

export default Selfie;
